/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var Countdown = /** @class */ (function () {
        function Countdown(config) {
            // dates are fun
            var date = new Date(config.timestamp * 1000);
            date.setHours(config.hours);
            date.setMinutes(config.minutes);
            date.setSeconds(0);
            this.countdownDate = date;
        }
        Countdown.prototype.run = function () {
            var second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
            var countDown = this.countdownDate.getTime();
            var dayselm = document.querySelector('.days .count');
            var hoursElm = document.querySelector('.hours .count');
            var minutesElm = document.querySelector('.minutes .count');
            var secondsElm = document.querySelector('.seconds .count');
            var x = setInterval(function () {
                var now = new Date().getTime(), distance = countDown - now;
                dayselm.innerText = String(Math.floor(distance / (day)));
                hoursElm.innerText = String(Math.floor((distance % (day)) / (hour)));
                minutesElm.innerText = String(Math.floor((distance % (hour)) / (minute)));
                secondsElm.innerText = String(Math.floor((distance % (minute)) / second));
                //do something later when date is reached
                if (distance < 0) {
                    window.location.reload();
                    clearInterval(x);
                }
            }, 100);
        };
        return Countdown;
    }());
    MoyaComponents.register('site.countdown', function (elm) {
        var config = {
            timestamp: Number(elm.dataset.countDownTimestamp),
            hours: Number(elm.dataset.countDownHours),
            minutes: Number(elm.dataset.countDownMinutes)
        };
        var countdown = new Countdown(config);
        countdown.run();
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
